// © Microsoft Corporation. All rights reserved.

import { ExceptionFetchingAccountInfo, ExceptionFetchingAuthToken, logException } from "@msnews/diagnostics";
import { IWidgetAuthenticator, IWidgetInstance } from "@msnews/core";

/**
 * Returns the account type of the user ie. "consumers" or "organizations"
 * @param widgetInstance The current widget's instance
 */
export async function getWindowsWidgetAccountType(widgetInstance: IWidgetInstance): Promise<string> {
    if (!widgetInstance) {
        return null;
    }

    try {
        const authenticatorApi = widgetInstance.tryGetApi<IWidgetAuthenticator>("authenticator", 1, 1);
        const accountType = await authenticatorApi.getProperty("ProviderAuthority");
        return accountType;
    } catch (error) {
        logException(error, ExceptionFetchingAccountInfo, "Exception fetching account type", `Error: ${JSON.stringify(error)}`);
        return null;
    }
}

/**
 * Fetches Windows Widget token for requested params
 * @param widgetInstance The current widget's instance
 * @param clientId The client id of the AAD application requesting access
 * @param scope The scope to request access for
 * @param resource The resource to request access for
 * @param apiVersion
 */
export async function getWindowsWidgetToken(widgetInstance: IWidgetInstance, clientId: string, scope: string, resource: string, apiVersion = ""): Promise<string> {
    if (!widgetInstance) {
        return null;
    }

    try {
        const authenticatorApi = widgetInstance.tryGetApi<IWidgetAuthenticator>("authenticator", 1, 1);
        const token = await authenticatorApi.getToken(clientId, scope, resource, apiVersion);
        return token;
    } catch (error) {
        logException(error, ExceptionFetchingAuthToken, "Exception fetching auth token", `Error: ${JSON.stringify(error)}`);
        return null;
    }
}